module.exports = __webpack_public_path__ + "img/f5_left.35ad9c95.png";